import { render, staticRenderFns } from "./SelectPlatform.vue?vue&type=template&id=ec9255e6&"
import script from "./SelectPlatform.vue?vue&type=script&lang=js&"
export * from "./SelectPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports